import React from 'react';
import styles from "./styles/OrderHeader.module.css";
import { FileTextOutlined } from '@ant-design/icons';

const OrderHeader = ({ status, orderType, ticket, hotstopArriveTime }) => {

  const getStatus = () => {
    const statusMap = {
      1: "Abierta",
      6: "orden nueva",
      7: "en preparación",
      8: "Asignada a driver",
      9: "Driver en domicilio",
      10: "Lista para domicilio",
      11: orderType === 1 || orderType === 0 ? "Lista para recoger" : "En camino",
      12: "Completada",
      15: "Cancelada"
    };

    return statusMap[status] || "Sin estado";
  };

  const formatTo12Hour = (time) => {
    if (!time) return "";

    const [hourStr, minute] = time.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // convierte 0 en 12
    return `${hour}:${minute} ${ampm}`;
  };



  return (
    <div className={styles.header}>
      <span className={styles.title}>
        {status === 5 || status === 4 ? 'Estatus de orden' : 'Detalle de pedido'}:
        <span className={styles.green}> {getStatus()}</span>
      </span>
      {
        orderType === 4 && (
          <span className={styles.ticketBox}>
            Hora de llegada aprox. 
            <span className={styles.green}>  {formatTo12Hour(hotstopArriveTime)}</span>
          </span>
        )
      }
      <div className={styles.ticketBox}>
        <FileTextOutlined className={styles.ticketIcon} />
        <span className={styles.ticketText}>TICKET: {ticket}</span>
      </div>
    </div>
  );

};

export default OrderHeader;
